module.exports = __webpack_public_path__ + "img/Title-EN.53d2e174.png";